const MaxLength = 254;

export default function isValidEmail(email: string): boolean {
	return email.length > 0 && email.length <= MaxLength && /^[^@ ]{1,63}@[^@ ]+\.[^. ]+$/.test(email);
}
